import { Card, FlexCrate, Text } from '@perch-labs/shrike';
import { copyFor } from 'config';
import { parseStatementPageData } from '../statement.api';

const getCopy = copyFor('billing.statement.paymentInstructions');

type PaymentInstructionsProps = Pick<
  ReturnType<typeof parseStatementPageData>,
  'paymentType' | 'projectDetails'
>;

export const PaymentInstructions = ({
  paymentType,
  projectDetails,
}: PaymentInstructionsProps): JSX.Element | null => {
  if (paymentType === 'nonAutoPayCheckToArcadia') {
    return (
      <>
        <Text>{getCopy('nonAutoPayCheckToArcadia.instruction')}</Text>
        <Text textStyle="paragraph400">Arcadia Power, Inc.</Text>
        <Text textStyle="paragraph400">ATTN: XGAX44</Text>
        <Text textStyle="paragraph400">2261 Market St, Ste 5792</Text>
        <Text textStyle="paragraph400">San Francisco, CA 94114</Text>
      </>
    );
  } else if (paymentType === 'nonAutoPayCheckToDeveloper' && projectDetails) {
    return (
      <>
        <Text>{getCopy('nonAutoPayCheckToDeveloper.instruction')}</Text>
        <Text textStyle="paragraph400">{projectDetails.projectName}</Text>
        <Text textStyle="paragraph400">{projectDetails.paymentAddress}</Text>
      </>
    );
  } else if (
    paymentType === 'nonAutoPayAchToDeveloper' &&
    projectDetails?.paymentBankDetails
  ) {
    return (
      <>
        <Text>{getCopy('nonAutoPayAchToDeveloper.instruction')}</Text>
        <Text textStyle="paragraph400">{projectDetails.projectName}</Text>
        <Text textStyle="paragraph400">
          {getCopy('nonAutoPayAchToDeveloper.bank')}{' '}
          {projectDetails.paymentBankDetails.bankName}
        </Text>
        <Text textStyle="paragraph400">
          {getCopy('nonAutoPayAchToDeveloper.routing')}{' '}
          {projectDetails.paymentBankDetails.bankRoutingNumber}
        </Text>
        <Text textStyle="paragraph400">
          {getCopy('nonAutoPayAchToDeveloper.account')}{' '}
          {projectDetails.paymentBankDetails.bankAccountNumber}
        </Text>
      </>
    );
  }
  return null;
};

export const PaymentInstructionsCard = ({
  paymentType,
  projectDetails,
}: PaymentInstructionsProps): JSX.Element | null => {
  const show = (
    [
      'nonAutoPayAchToDeveloper',
      'nonAutoPayCheckToArcadia',
      'nonAutoPayCheckToDeveloper',
    ] as PaymentInstructionsProps['paymentType'][]
  ).includes(paymentType);

  if (show) {
    return (
      <Card
        mobileVariant="flat"
        margin="0 0 32px 0"
        data-testid="statement-payment-instructions"
      >
        <Card.Content>
          <FlexCrate flexDirection="column" margin="24px 0 0 0" gap="8px">
            <PaymentInstructions
              paymentType={paymentType}
              projectDetails={projectDetails}
            />
          </FlexCrate>
        </Card.Content>
      </Card>
    );
  }
  return null;
};
